(function ($) {
  
  const endpoint = "https://rebalance-prod.warreng.workers.dev";

  function getAnswerText(questionId, answerId) {
      var answerId = parseInt(answerId);
      const question = cortisolQuestions.find(q => q.question_id === questionId);
      if (question) {
          const answer = question.answers.find(a => a.answer_id === answerId);
          return answer ? answer.answer_text : null;
      }
      return null;
  }  

  function determineProduct(gender, ageRange) {
      const age = getHighestAgeFromRange(ageRange);
      let product = 'anxiety';
      if (gender === 'Male') {
          if (age > 44) {
              product = 'testosterone';
          }
      } else if (gender === 'Female') {
          if (age > 44) {
              product = 'hotflash';
          }
      }
      return product;
  }

  function getHighestAgeFromRange(ageRange) {
      const ageParts = ageRange.split('-');
      if (ageParts.length > 1) {
          return parseInt(ageParts[1], 10);
      } else if (ageRange.endsWith('+')) {
          return parseInt(ageRange.slice(0, -1), 10);
      }
      return parseInt(ageRange, 10);
  }

  function determineRanking(totalScore) {
    if (totalScore >= 0 && totalScore <= 29) {
        return 0; // Poor
    } else if (totalScore >= 30 && totalScore <= 59) {
        return 1; // Good
    } else if (totalScore >= 60 && totalScore <= 89) {
        return 2; // Better
    } else if (totalScore >= 90 && totalScore <= 100) {
        return 3; // Best
    }
  }

  function updateScaleUI(ranking, totalScore) {

    $('#result-poor').removeClass('active');
    $('#result-good').removeClass('active');
    $('#result-better').removeClass('active');
    $('#result-best').removeClass('active');

    switch (ranking) {
        case 0:
            $('#result-poor').addClass('active').find('em').text(totalScore);
            break;
        case 1:
            $('#result-good').addClass('active').find('em').text(totalScore);
            break;
        case 2:
            $('#result-better').addClass('active').find('em').text(totalScore);
            break;
        case 3:
            $('#result-best').addClass('active').find('em').text(totalScore);
            break;
    }
  }

  $(document).ready(function () {
    const SURVEY_ID = 1; // Set your survey ID here
    let surveyUuid = localStorage.getItem("surveyUuid");
    let responseValues =
      JSON.parse(localStorage.getItem("responseValues")) || {};
    let scoringThresholds = [];

    // Create loading animation element
    const loadingAnimation = $(
      '<div id="loading-animation" class="loading-animation">Loading...</div>'
    );
    $("body").append(loadingAnimation);

    function showLoading() {
      $("#loading-animation").show();
    }

    function hideLoading() {
      $("#loading-animation").hide();
    }

    function fetchQuestions() {
      $.ajax({
        url: `${endpoint}/fetchquestions?surveyId=${SURVEY_ID}`,
        method: "GET",
        beforeSend: showLoading,
        success: function (data) {
          const {
            survey_title,
            survey_description,
            questions,
            scoring_thresholds,
          } = data;
          window.cortisolQuestions = questions;
          scoringThresholds = scoring_thresholds;
          buildForm(survey_title, survey_description, questions);
          populateForm(responseValues);
        },
        error: function (error) {
          console.error("Error fetching data:", error);
        },
        complete: hideLoading,
      });
    }

    fetchQuestions();

    function buildForm(surveyTitle, surveyDescription, questions) {
      const headerContent = $(`<div class="quiz-title-header v2">  
              <div class="title-wrap">
                <h1>Is Stress Hijacking <br>Your Health?</h1>
                <p>Exhausted, overwhelmed, and wondering where your spark went? You’re not imagining it. Stress is sneaky, and when it throws your cortisol levels out of whack, it can be the root cause of poor sleep, unstable moods, low workout recovery, lost libido, and even exacerbate hormonal changes as we age.</p>
                <p>You’re not alone—and there’s a way to take control. Take this quiz to see if cortisol might be the culprit behind how you’re feeling.</p>
              </div>
            </div>
            <form id="sticky-form">
            <div class="question-group">
              <div class="question-row">
                  <div class="form-group">
                      <label for="name">Name</label>
                      <input class="form-control" type="text" id="name" name="name" placeholder="First Last" required>
                  </div>
              </div>
              <div id="demographics-row" class="question-row flex-container">
                ${questions
          .filter(
            (question) =>
              question.question === "Age" ||
              question.question === "Height" ||
              question.question === "Weight" ||
              question.question === "Gender (assigned at birth)"
          )
          .map(
            (question) => `
                  <div class="question-col">
                    <div class="form-group">
                      <label for="question-${question.question_id}">${question.question}</label>
                      <select class="form-control" id="question-${
              question.question_id
            }" name="question-${question.question_id}">
                        <option value="" selected disabled>Select</option>
                        ${question.answers
              .map(
                (answer) =>
                  `<option value="${answer.answer_id}" data-group="${answer.subgroup}" data-sort="${answer.sort_order}">${answer.answer_text}</option>`
              )
              .join("")}
                      </select>
                    </div>
                  </div>`
          )
          .join("")}
              </div>
              <div class="question-row">
                  <div class="form-group text-center">
                      <button id="btn-start" type="button" class="form-control btn-lets-go">Let's go!</button>
                  </div>
              </div>
            </div>
            </form>
            </div>`);
;


      // Add event listener to the start button
      headerContent.find("#btn-start").on("click", function () {
        // Handle form submission and inject slick slider container
        const $btn = $(this);
        const name = $("#name").val();
        const age = $("#question-0").val();
        const height = $("#question-1").val();
        const weight = $("#question-2").val();
        const gender = $('#question-12').val();

        window.cortisolData = {
          name: name,
          age: age,
          height: height,
          weight: weight,
          gender: gender,
        };

        if (!name || !age || !height || !weight || !gender) {
          showToast("Please fill out all the fields in the form", "error");
          return;
        }

        responseValues["name"] = {
          answer_id: name,
          subgroup: null,
          sort_order: null,
        };
        responseValues["0"] = {
          answer_id: age,
          subgroup: $("#question-0 option:selected").data("group"),
          sort_order: $("#question-0 option:selected").data("sort"),
        };
        responseValues["2"] = {
          answer_id: weight,
          subgroup: $("#question-2 option:selected").data("group"),
          sort_order: $("#question-2 option:selected").data("sort"),
        };
        responseValues["1"] = {
          answer_id: height,
          subgroup: $("#question-1 option:selected").data("group"),
          sort_order: $("#question-1 option:selected").data("sort"),
        };
        responseValues["12"] = {
          answer_id: gender,
          subgroup: $("#question-12 option:selected").data("group"),
          sort_order: $("#question-12 option:selected").data("sort"),
        };
        localStorage.setItem("responseValues", JSON.stringify(responseValues));
        localStorage.setItem("surveyUuid", surveyUuid);

        // Inject slick slider container
        $("#sticky-form").after(`
          <form id="dynamic-form">
          <div id="quiz-card" class="slick-slider"></div>
          <button type="button" class="prev-slide">Previous</button>
          <button type="button" class="next-slide">Next</button>
          </form>`);

        buildSlides(questions);
        initializeSlider();
        //console.log("Slider next button Populate form data", responseValues);
        populateForm(responseValues); // Populate the form after building it
        $btn.hide();
      });

      $("#mojo-meter").prepend(headerContent);
    }

    function buildSlides(questions) {
      const slides = {
        otherSlides: [],
      };

      questions.forEach((question, index) => {
        if (
          question.question === "Age" ||
          question.question === "Height" ||
          question.question === "Weight" ||
          question.question.includes('Gender')
        ) {
          return; // Skip these questions as they are in the header
        }

        const questionContainer = $('<div class="quiz-card-block"></div>');
        questionContainer.append(
          `<h2>${(index - 3).toString()}</h2><h3>${question.description}</h3>`
        );
        /* // Don't show question labels
        questionContainer.append(
          `<label class="question-label" for="question-${question.question_id}">${question.question}</label>`
        );
        */

        let inputElement;

        switch (question.input_type) {
          case "select":
            inputElement = $(
              `<select id="question-${question.question_id}" name="question-${question.question_id}"></select>`
            );
            inputElement.append('<option value="">Select</option>');
            question.answers.forEach((answer) => {
              inputElement.append(
                `<option class='form-control' value="${answer.answer_id}" data-group="${answer.subgroup}" data-sort="${answer.sort_order}">${answer.answer_text}</option>`
              );
            });
            break;
          case "checkbox":
            inputElement = $("<div class='checkbox-group'></div>");
            question.answers.forEach((answer) => {
              inputElement.append(
                `<div class="input-group"><input class='checkbox-control' type="checkbox" id="answer-${answer.answer_id}" name="question-${question.question_id}" value="${answer.answer_id}" data-group="${answer.subgroup}" data-sort="${answer.sort_order}"><label for="answer-${answer.answer_id}">${answer.answer_text}</label></div>`
              );
            });
            break;
          case "radio":
            inputElement = $("<div class='radio-group input-group'></div>");
            question.answers.forEach((answer) => {
              inputElement.append(
                `<div class="input-group"><input class="radio-control" type="radio" id="answer-${answer.answer_id}" name="question-${question.question_id}" value="${answer.answer_id}" data-group="${answer.subgroup}" data-sort="${answer.sort_order}"><label for="answer-${answer.answer_id}">${answer.answer_text}</label></div>`
              );
            });
            break;
          case "text":
            inputElement = $(
              `<input class='input-group' type="text" id="question-${question.question_id}" name="question-${question.question_id}" placeholder="Enter text">`
            );
            break;
          case "yesno":
            inputElement = $("<div class='yesno-group input-group'></div>");
            inputElement.append(
              `<div class="input-group"><input type="radio" id="yes-${question.question_id}" name="question-${question.question_id}" value="yes"><label for="yes-${question.question_id}">Yes</label></div>`
            );
            inputElement.append(
              `<div class="input-group"><input type="radio" id="no-${question.question_id}" name="question-${question.question_id}" value="no"><label for="no-${question.question_id}">No</label></div>`
            );
            break;
          default:
            console.error("Unknown input type:", question.input_type);
            break;
        }

        questionContainer.append(inputElement);
        const slide = $('<div class="quiz-card-wrap"></div>').append(
          questionContainer
        );
        slides.otherSlides.push(slide);
      });

      $("#quiz-card").append(slides.firstSlide);
      slides.otherSlides.forEach((slide) => $("#quiz-card").append(slide));

      const finalSlide = $(`
        <div class="quiz-card-wrap finish final-terms-wrap">
            <div class="quiz-title-header">
                <div class="title-wrap">
                <h1>You're all done!</h1>
                <p>Do you agree to our <a class="cortisol-tos" href="/pages/terms-of-service" target="_blank">Terms of Service</a>?</p>
                </div>
            </div>
            <div class="entry-content-wrapper">
                <form id="final-form">
                <div class="radio-button-group radio-style">
                    <div class="radio-button">
                    <input type="radio" name="service_agree" id="Iaccept" value="yes">
                    <label for="Iaccept">I accept</label>
                    </div>
                    <div class="radio-button">
                    <input type="radio" name="service_agree" id="Idonotaccept" value="no">
                    <label for="Idonotaccept">I do not accept</label>
                    </div>
                    <div class="error-message" id="terms-error">Please accept our terms of service.</div>
                </div>
                <div class="quiz-title-header">
                    <div class="title-wrap">
                    <p>Share your email to view your results</p>
                    </div>
                </div>
                <div class="form-group-email">
                    <label for="email" style="display:none;">Email</label>
                    <input class="form-control" placeholder="Email" type="email" id="email" name="email" required>
                    <div class="error-message" id="email-error">Please enter a valid email address.</div>
                </div>
                <div class="form-group text-center">
                    <button id="btn-submit" type="submit" class="form-control">Submit</button>
                </div>
                </form>
            </div>
            </div>`);

      $("#quiz-card").append(finalSlide);

      $('#final-form').on("submit", function (event) {
        // Get current slide index on init
        var currentSlide = $("#quiz-card").slick("slickCurrentSlide");
        
        event.preventDefault();
        if (validFinalForm()) {
            $("#btn-submit").addClass("is-loading");
            const finalData = {
                id: surveyUuid,
                name: $("#name").val(),
                email: $("#email").val(),
                opt_in: $('input[name="service_agree"]:checked').val(),
                response_values: responseValues,
                survey_id: SURVEY_ID,
            };
            console.log("Final Form Data", finalData);

            $.ajax({
            url: `${endpoint}/savedata`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(finalData),
            beforeSend: showLoading,
            success: function (response) {

              showToast("Final data saved successfully");

              const questionScores = {};
              const { response_values } = response;
              const keys = Object.keys(response_values);

              keys.forEach((key) => {

              if (response_values[key].questionLabel) {
                questionScores[response_values[key].question] =
                response_values[key].score;
              }
              });

              const formattedObject = {
                question: questionScores,
                name: response_values["name"].answer_id,
                Score: response.score,
                LifestyleLevel: response.Lifestyle,
              };
              /* Facebook Pixel Tracking */
              fbq('track', 'Lead');
              fbq('trackCustom', 'CortisolSurvey', {
                gender: cortisolData.gender,
                age: cortisolData.age,
                score: response.score
              });

              localStorage.removeItem("responseValues");
              localStorage.removeItem("surveyUuid");
              performAction(formattedObject);
              if(typeof LogRocket !== 'undefined') 
                LogRocket.identify(finalData.id, {
                  name: finalData.name,
                  email: finalData.email,
                  score: response.score,
                });

            },
            error: function (error) {
                showToast("Error saving final data", "error");
            },
            complete: function() {
              hideLoading();
              $("#btn-submit").removeClass("is-loading");
            }
          });
        }
      });
    }

    function populateForm(data) {
      setTimeout(() => {
        //console.log("Populating form with data:", data);
        if (data.name) $("#name").val(data.name.answer_id);
        if (data.email) $("#email").val(data.email);
        if (data.opt_in) $("#opt-in").prop("checked", data.opt_in);
        Object.entries(data).forEach(([key, value]) => {
          // console.log(`Key: ${key}, Value:`, value);
          const questionId = key;
          const {
            answer_id: answerId,
            subgroup: subgroup,
            sort_order: sortOrder,
          } = value;

          const selectElement = $(`#question-${questionId}`);
          // console.log("Select elements", selectElement);
          if (selectElement.length) {
            const optionToSelect = selectElement.find(
              `option[value="${answerId}"]`
            );
            if (optionToSelect.length > 0) {
              // console.log("Select elements ID", optionToSelect);
              selectElement.val(answerId);
              selectElement.addClass("is-active");
            }
          } else {
            $(`input[name="question-${questionId}"][value="${answerId}"]`).prop(
              "checked",
              true
            );
          }
        });
      }, 1000);
    }

    function saveData(currentSlide, totalSlides) {
      if (currentSlide < totalSlides - 1) {
        // Find the current slide element
        const currentSlideElement = $(
          `#quiz-card .slick-slide[data-slick-index="${currentSlide}"]`
        );

        //console.log("Save current slide", currentSlideElement);
        let answer = null;
        let question = null;
        let group = null;
        let sortOrder = null;

        const questionLabel = currentSlideElement.find("h3").text();
        //console.log("Question Label==========", questionLabel);

        if (currentSlideElement.find('input[type="radio"]').length > 0) {
          let $sel = currentSlideElement.find('input[type="radio"]:checked');
          if ($sel.length > 0) {
            answer = $sel.val();
            //console.log("Save current slide Answer", answer);
            question = $sel.attr("name").split("-")[1];
            group = $sel.data("group");
            sortOrder = $sel.data("sort");
          } else {
            showToast("Problem Saving", "error");
          }
        } else if (currentSlideElement.find("select").length > 0) {
          let $sel = currentSlideElement.find("select").find("option:selected");
          if ($sel.length > 0) {
            answer = $sel.val();
            question = $sel.attr("name").split("-")[1];
            group = $sel.data("group");
            sortOrder = $sel.data("sort");
          } else {
            showToast("Problem Saving", "error");
          }
        }

        if (question !== null && answer !== null) {
          responseValues[question] = {
            answer_id: answer,
            subgroup: group,
            sort_order: sortOrder,
            questionLabel: question,
          };
          localStorage.setItem(
            "responseValues",
            JSON.stringify(responseValues)
          );
          // performAction();
          $("#quiz-card").slick("slickNext");
        }
      }
    }

    function initializeSlider(goTo) {
      var totalSlides = null;
      var currentSlider = 0; // Variable to store the current slide index
      $slider = $("#quiz-card").slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        adaptiveHeight: false,
        swipe: false
      });
      $(".prev-slide").addClass("disabled");
      $slider.on("init reInit", function (slick) {
        totalSlides = slick.slideCount;
      });

      $slider.on("afterChange", function (event, slick, newIndex) {
        currentSlider = newIndex;

        if (currentSlider === slick.slideCount - 2) {
          $(".final-terms-wrap").css("opacity", "0");
        } else {
          $(".final-terms-wrap").css("opacity", "1");
        }

        if (currentSlider === slick.slideCount - 1) {
          $(".next-slide").addClass("disabled");
          $(".quiz-title-header").first().hide();
          $("#sticky-form").hide();
          $("#mojo-meter").addClass("is-completed");
          $(`.slick-slide[data-slick-index="${slick.slideCount - 2}"]`).css(
            "opacity",
            "0"
          );
        } else {
          $(".next-slide").removeClass("disabled");
          $(".quiz-title-header").first().show();
          $("#sticky-form").show();
          $("#mojo-meter").removeClass("is-completed");
          $(`.slick-slide[data-slick-index="${slick.slideCount - 2}"]`).css(
            "opacity",
            "1"
          );
        }

        if (currentSlider === 0) {
          $(".prev-slide").addClass("disabled");
        } else {
          $(".prev-slide").removeClass("disabled");
        }
      });

      // Attach event handlers to custom Navigation buttons (Custom Next Nevigation)
      $(".next-slide").on("click", function () {
        const currentSlideElement = $slider.find(
          `.slick-slide[data-slick-index="${currentSlider}"]`
        );

        const totalSlide = $("#quiz-card").slick("getSlick").slideCount;
        if (!$(this).hasClass("disabled")) {
          // Prevent slide transition if no valid input not selected
          if (!validateCurrentSlide(currentSlideElement)) {
            showToast("Please fill out the form before proceeding.", "error");
            return false;
          }
          saveData(currentSlider, totalSlide);
        }
      });

      // Custom Previous Nevigation
      $(".prev-slide").on("click", function () {
        if (!$(this).hasClass("disabled")) {
          $("#quiz-card").slick("slickPrev");
        }
      });

      $slider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          // Validate before changing the slide
        }
      );
    }

    function validateCurrentSlide(currentSlideElement) {
      // const currentSlideElement = $(
      //   `#quiz-card .slick-slide[data-slick-index="${currentSlide}"]`
      // );

      let isValid = false;

      // Check for selected value in select fields
      const selectField = currentSlideElement.find("select");
      if (selectField.length > 0) {
        isValid = selectField.val() !== "";
      }

      // Check for checked radio buttons
      const radioField = currentSlideElement.find(
        'input[type="radio"]:checked'
      );
      if (radioField.length > 0) {
        isValid = true;
      }

      // Check for checked checkboxes
      const checkboxField = currentSlideElement.find(
        'input[type="checkbox"]:checked'
      );
      if (checkboxField.length > 0) {
        isValid = true;
      }

      // Check for text input values
      const textField = currentSlideElement.find('input[type="text"]');
      if (textField.length > 0) {
        isValid = textField.val().trim() !== "";
      }

      // Check for email input values
      const emailField = currentSlideElement.find('input[type="email"]');
      if (emailField.length > 0) {
        isValid = emailField.val().trim() !== "";
      }

      // Check for yes/no fields (assuming they are radio buttons)
      const yesNoField = currentSlideElement.find(
        'input[type="radio"][name="yesno"]:checked'
      );
      if (yesNoField.length > 0) {
        isValid = true;
      }

      return isValid;
    }

    function validFinalForm() {
        let isValid = true;

        // Email validation
        const email = $('#email').val().trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email === '' || !emailPattern.test(email)) {
            $('#email').addClass('invalid');
            $('#email-error').show();
            isValid = false;
        } else {
            $('#email').removeClass('invalid');
            $('#email-error').hide();
        }

        // Terms and conditions validation
        if (!$('input[name="service_agree"]:checked').val() || $('input[name="service_agree"]:checked').val() !== 'yes') {
            $('#terms-error').show();
            isValid = false;
        } else {
            $('#terms-error').hide();
        }

        return isValid;
    }

    function showResults(score) {
      const threshold = scoringThresholds.find(
        (th) => score >= th.min && score <= th.max
      );
      const resultDescription = threshold
        ? threshold.description
        : "No description available.";

      const resultsSlide = $(`
            <div class="slide results-slide">
              <div class="results-container">
                <h2>Your Results</h2>
                <p>Your score is: ${score}</p>
                <p>${resultDescription}</p>
              </div>
            </div>
          `);

      $slider.slick("slickAdd", resultsSlide);
      $slider.slick("slickNext");
    }

    function showToast(message, type = "success") {
      const toast = $(`<div class="toast ${type}">${message}</div>`);
      $("body").append(toast);
      setTimeout(() => {
        toast.fadeOut(300, () => {
          toast.remove();
        });
      }, 3000);
    }

    // Event Listner to close overlay
    // Function to handle the action
    function performAction(userData = null) {
      // Notify the parent window to remove the overlay and send data
      window.parent.postMessage(
        {
          action: "sendCortisolTestData",
          payload: userData !== null ? userData : null,
        },
        window.location.origin
      );
    }
  });

  /**
   *  Result Page Js
   *  Display Chart,total score and update contents
   */
  window.addEventListener("message", function (event) {

    if (event.origin !== window.location.origin) {
      console.error("Origin mismatch:", event.origin);
      return;
    }

    if (event.data.action === "sendCortisolTestData") {

        const userValues = {
            name: cortisolData.name,
            gender: getAnswerText(12, cortisolData.gender),
            age: getAnswerText(0, cortisolData.age),
            height: getAnswerText(1, cortisolData.height),
            weight: getAnswerText(2, cortisolData.weight)
        };
        userValues.product = determineProduct(userValues.gender, userValues.age);

      $(".main-content").show();
      const userData = event.data.payload;
      //console.log("userData", userData);
      //console.log("Response", userData.question);
      if (userData && Object.keys(userData).length > 0) {
        const totalScore = userData.Score;
        const ranking = determineRanking(totalScore);
        updateUI(ranking, totalScore);
        $("#user_name").text(userData.name);
      } else {
        console.warn("Received empty userData");
        // Handle empty userData if necessary
      }
      // Scroll to the top of the page
      $("html, body").animate({ scrollTop: 0 }, "slow");
      document.getElementById("overlay").classList.add("hidden");
      $("body").addClass('results-page').removeClass('has-overlay');
      $(`#${userValues.product}`).show();
    }
  });

  function updateChart(data) {
    // Prepare data for Highcharts
    const labels = Object.keys(data);
    const scores = Object.values(data);
    const colors = [
      "#3B2E91",
      "#16AFD8",
      "#D0CEE2",
      "#FDD355",
      "#3B2E91",
      "#16AFD8",
      "#D0CEE2",
      "#FDD355",
      "#3B2E91",
    ];

    // Calculate percentage values based on score values
    const minScore = Math.min(...scores);
    const maxScore = Math.max(...scores);

    const percentageValues = scores.map((score) => {
      const percentage = ((score - 1) / 4) * 90 + 10; // Map score range [1, 5] to percentage range [10, 100]
      return Math.round(percentage);
    });
    //console.log("percentageValues", percentageValues);

    // Generate the Highcharts chart
    Highcharts.chart("chart_wrap", {
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: labels,
        title: {
          // text: "Questions",
        },
      },
      yAxis: {
        min: 10,
        max: 100,
        tickInterval: 10,
        title: {
          text: "",
        },
        labels: {
          enabled: false, // Disable y-axis labels
        }
        // labels: {
        //   formatter: function () {
        //     return this.value + "%";
        //   },
        // },
      },
      plotOptions: {
        column: {
          pointPadding: 0.1, // Reduce space between columns
          groupPadding: 0.1, // Reduce space between column groups
          borderWidth: 0,
        },
      },
      series: [
        {
          name: "Scores",
          data: percentageValues.map((percentage, index) => ({
            y: percentage,
            color: colors[index % colors.length],
          })),
          colorByPoint: true,
        },
      ],
      credits: {
        enabled: false, // Disable Highcharts credits
      },
      legend: {
        enabled: false,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 600,
            },
            chartOptions: {
              legend: {
                enabled: false,
              },
            },
          },
        ],
      },
    });
  }


  function updateUI(ranking, totalScore) {
    // Remove 'active' class from all result elements
    $('#result-poor').removeClass('active');
    $('#result-good').removeClass('active');
    $('#result-better').removeClass('active');
    $('#result-best').removeClass('active');

    // Update the UI based on the ranking
    const contents = {
        0: {
            heading: "Out of whack",
            subtitle: "Cortisol Overload Alert",
            message:
                "<p>It’s highly likely that dysregulated cortisol is throwing your mind and body off balance. This can cause restless nights, brain fog, low energy, and more. The good news? You can take control. Check your email for personalized insights and resources to reclaim your health and well-being.</p>",
            paragraph1:
                "Your cortisol levels have likely been elevated for a while, which can lead to hormone imbalance. Even if you don't feel stressed, your body might be taking the brunt of the effects.",
            paragraph2:
                "High cortisol levels can disrupt sleep, and poor sleep can, in turn, raise cortisol levels. Your diet might need some adjustments, and staying hydrated is essential. Prioritizing deep sleep, eating a balanced diet, and drinking plenty of water each day are the first steps.",
            image:
                "https://cdn.shopify.com/s/files/1/0517/7321/0786/files/out-of-wack.png?v=1722942890",
        },
        1: {
            heading: "Stress Is Taking Its Toll",
            subtitle: "Good not Great",
            message:
                "<p>Your results suggest that stress may be starting to take a toll on your cortisol levels. This could affect your sleep, energy, and mood. But there’s hope! Check your email for actionable steps to start taking control and feeling like yourself again.</p>",
            paragraph1:
                "Your cortisol levels may have been elevated for a while, which can lead to hormone imbalance. Even if you don't feel stressed, your body might be taking the brunt of the effects.",
            paragraph2:
                "High cortisol levels can disrupt sleep, and poor sleep can, in turn, raise cortisol levels. Your diet might need some adjustments, and staying hydrated is essential. Prioritizing deep sleep, eating a balanced diet, and drinking plenty of water each day are the first steps.",
            image:
                "https://cdn.shopify.com/s/files/1/0517/7321/0786/files/doing-ok.png?v=1722942889",
        },
        2: {
            heading: "Today is a new day",
            subtitle: "Slightly Off Balance",
            message:
                "<p>Your cortisol levels might be a little off balance, but don’t worry—it’s manageable! Small adjustments to your daily habits can make a big difference. Look for an email with practical tips to help you feel more in sync and energized.</p>",
            paragraph1:
                "Your cortisol is likely close to being balanced but may be out of whack at the wrong times. Most symptoms of high cortisol are rolled into the normal impacts of aging.",
            paragraph2:
                "It's possible you may just need better sleep. Imbalanced cortisol levels can disrupt sleep, and poor sleep can lead to elevated cortisol levels. Getting deep, restorative sleep will support your body's ability to regulate your hormone levels throughout the day.",
            image:
                "https://cdn.shopify.com/s/files/1/0517/7321/0786/files/doing-great.png?v=1722942890",
        },
        3: {
            heading: "Doing great, keep it going",
            subtitle: "Balanced and Thriving",
            message:
                "<p>Your cortisol levels look great—you’re living a healthy, balanced life! Keep up the good work by maintaining your wellness habits. Check your email for more tips on how to stay on track and support your overall health.</p>",
            paragraph1:
                "You're probably feeling great most days. The key to living life in balance is making a commitment to maintaining your health, despite life's ups and downs. It's okay to have the occasional off day. Afterall, we're human!",
            paragraph2:
                "Make sure to continue getting enough sleep, and there's always room for improvement. Letting your sleep hygiene slip can lead to elevated cortisol levels, and vice versa. If you ever need some extra support, we're here for you!",
            image:
                "https://cdn.shopify.com/s/files/1/0517/7321/0786/files/doing-great.png?v=1722942890",
        },
    };

    const { image, heading, subtitle, message, paragraph1, paragraph2 } = contents[ranking];

    // Add 'active' class and update <em> tag based on the ranking
    switch (ranking) {
        case 0:
            $('#result-poor').addClass('active').find('em').text(totalScore);
            break;
        case 1:
            $('#result-good').addClass('active').find('em').text(totalScore);
            break;
        case 2:
            $('#result-better').addClass('active').find('em').text(totalScore);
            break;
        case 3:
            $('#result-best').addClass('active').find('em').text(totalScore);
            break;
    }

    // Update dynamic content
    //$("#hero-image").attr("src", image);
    $('.cortisol-results-content h2').text(heading);
    $('.cortisol-results-content h3').text(subtitle);
    $('.cortisol-results-content span').html(message);
    //$("#result_heading").text(heading);
    //$("#result_message").html(message);
    $("#result_paragraph1 p").html(paragraph1);
    $("#result_paragraph2 p").html(paragraph2);
}

})(jQuery);
